import * as React from 'react';
import { useTheme } from '@websky/core/src/theme';
import { Clock } from './Icons';
const DescriptionRender = () => {
    const { DescriptionBlock: css } = useTheme('FareLock');
    return React.createElement("div", { className: css.icon }, Clock);
};
export default DescriptionRender;
